import { HttpClient } from "../api/httpclient.service";

export interface SolutionValidationResponse {
  status: "success" | "error" | "incorrect" | "low_ocr_confidence";
  overall_score: number;
  total_questions: number;
  correct_count: number;
  partial_count: number;
  incorrect_count: number;
  summary_text: string;
  detailed_feedback: any | null;
  solution_id: number;
  xp_awarded: number;
  ocr_confidence: number | null;
  question_id: number | null;
  solution_image_url?: string;
  solution_image_urls?: string[];
  image_count?: number;
}

export class SolutionValidatorService extends HttpClient {
  constructor() {
    super();
  }

  public async uploadSolution(imageBlobs: Blob[], exerciseId: number, questionId?: number): Promise<SolutionValidationResponse> {
    const formData = new FormData();
    imageBlobs.forEach((blob, index) => {
      formData.append("images", blob, `solution_page_${index + 1}.jpg`);
    });
    formData.append("exercise_id", String(exerciseId));
    if (questionId) {
      formData.append("question_id", String(questionId));
    }

    return await this.post("/solution-validator/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 120000, // OCR + LLM execution can take 10-17s, aggressive timeout 2m to be safe.
    });
  }

  public async getUserExerciseSolutions(userId?: number, limit: number = 50, offset: number = 0): Promise<any[]> {
    const userParam = userId !== undefined && userId !== null && !isNaN(userId) ? `&user_id=${userId}` : '';
    return await this.get(`/solution-validator/user-solutions?limit=${limit}&offset=${offset}${userParam}`);
  }
}
